import { z } from 'zod';

export enum CreatingSchemaMethod {
  EMPTY = 'EMPTY',
  CLONE = 'CLONE',
}

const isValidSourceSchemaName = (creatingMethod: CreatingSchemaMethod, sourceSchemaName?: string): boolean => (
  creatingMethod === CreatingSchemaMethod.EMPTY ? true : !!sourceSchemaName
);

export const schemaFormValidation = z.object({
  schemaName: z.string().min(1),
  creatingMethod: z.nativeEnum(CreatingSchemaMethod),
  sourceSchemaName: z.string().optional(),
}).refine(
  dataForm => isValidSourceSchemaName(dataForm.creatingMethod, dataForm.sourceSchemaName),
  { message: 'ascsd' },
);

export type CreateSchemaDataForm = z.infer<typeof schemaFormValidation>;

